export const Interes_item = [
    
    // {
    //     'nombre': '',
    //     'url':'../Areas',
    //     'icon': 'Areas.png'
    // },
    // {
    //     'nombre': '',
    //     'url':'../Indicadores',
    //     'icon': 'Indicadores.png'
    // },
    {
        'nombre': '',
        'url':'/ComiteEtica',
        'icon': 'Comite.png'
    },
    {
        nombre: '',
        url:'../AgroquimicosAbejas',
        icon: 'Argoquimicos.png'
    },
    {
        nombre: "",
        url: "../ManualOrganizacion",
        icon: "Organizacion.png",
      },
      {
        nombre: "",
        url: "../Estructura",
        icon: "Estructura.png",
      },
      {
        nombre: "",
        url: "../ManualProcedimientos",
        icon: "Procedimientos.png",
      },
    {
        'nombre': '',
        'url':'/CIDT',
        'icon': 'CIDT.png'
    },
    {
        'nombre': '',
        'url':'/CodigoConducta',
        'icon': 'Conducta.png'
    },
    {
        'nombre': '',
        'url':'/Cocodi',
        'icon': 'COCODI.png'
    },
    {
        nombre: '',
        url:'/Manualinterno',
        icon: 'Interno.png'
    },
    
    
    {
        'nombre': '',
        'url':'../ProtocoloCero',
        'icon': 'Acciones.png'
    },

]